declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, StoreLocationMaterialsRequest, StoreLocationMaterialsController, MaterialBatchInaStoreController, DoctorsListController, DoctorsListRequest, MaterialsListController, MaterialsListRequest, PurchaseOrdersListController, PurchaseOrderDetailsController, PurchaseOrderDetailsRequest, PurchaseOrderDetailsInfoController, SaveVendorInvoice, VendorInvoiceItemRequest, S_Methods, GenericProcPostRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbBatchDetail2Modal } from '../consumptionentry/batchdetail2.modal';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
import { NgbGoodsInvoiceModal } from './modal/goodsinvoice.modal';
import { NgbEditPIitemsModal } from './modal/editPIitems.modal';





@Component({
  selector: 'invoicereceipt',
  templateUrl: './invoicereceipt.component.html',
  styleUrls: ['./invoicereceipt.component.scss']
  , animations: [routerTransition()]
})

export class InvoiceReceiptComponent implements OnInit {


  public ApiResData: ApiResponseModel;
  public ActorCode: number = 0;
  public isRequesting: boolean = false;
    public searchValue: string;
  public BranchName: string;
  public Date: Date;
  public ActorCode2: number;
  public FacilityCode: number;
  searchTitle: string;
  public DefaultExpDate: NgbDateStruct;
  public MfgDate: NgbDateStruct;
  PaymentDueDate: NgbDateStruct;
  InvoiceDate: NgbDateStruct;
  TodayDate = new Date();
  public DocIDdata: string;

  public UnitPrice: number;
  public TaxPercent: number;
  public ItemTax: number;
  public Quantity: number;
  public BonusQuantity: number = 0;
  public TotalOrderQuantity: number;
  public UomName: string;
  public Mrp: number;
  public Pack: number;
  public PurchasePrice: number;
  public SalePrice: number;
  public isvisible: boolean = true;

  public PurchaseOrderCode: any;
  public OrderStatus: any;
  public ShipToLocationCode: any;
  public ShipToLocationdata: any;
  public SupplierCode: any;
  public SupplierName: any;
  public RefNo: any;
  public OrderDate: any;
  public DeliveryDate: any;
  public Tax: any;
  public GrandTotal: any;
  public TotalBeforeDiscount: any;

  //public OrderDatedate: NgbDateStruct;
  //public DeliveryDatedate: NgbDateStruct;

  CurrentSaveVendorInvoiceRequest: SaveVendorInvoice;

  CurrentPurchaseOrderHeaderDetailsController: PurchaseOrdersListController;
  CurrentPurchaseOrderDetailsController: PurchaseOrderDetailsController[];
  CurrentPurchaseOrderDetailsRequest: PurchaseOrderDetailsRequest;
  PurchaseOrderDataHeader: PurchaseOrderDetailsInfoController;

  //header + items
  PurchaseInvoiceData: SaveVendorInvoice;

  LoadItems() {
    this.CurrentPurchaseOrderDetailsRequest = new PurchaseOrderDetailsRequest();
    this.CurrentPurchaseOrderDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPurchaseOrderDetailsController();
  }
  CopyOrderToInvoice() {
    this.PurchaseInvoiceData.HasPO = true;

    this.PurchaseInvoiceData.DocID = this.DocIDdata;
    this.PurchaseInvoiceData.PurchaseOrderCode = this.PurchaseOrderCode;
    this.PurchaseInvoiceData.InvoiceStatus = this.OrderStatus;
    this.PurchaseInvoiceData.OwnerStore = this.ShipToLocationCode;
    this.PurchaseInvoiceData.OwnerStoreName = this.ShipToLocationdata;

    this.PurchaseInvoiceData.VendorCode = this.SupplierCode;
    this.PurchaseInvoiceData.VendorName = this.SupplierName;
    this.PurchaseInvoiceData.RefDocNo = this.RefNo;
    this.PurchaseInvoiceData.InvDate = new Date(this.parserFormatter.format(this.OrderDate));
    this.PurchaseInvoiceData.PaymentDue = new Date(this.parserFormatter.format(this.DeliveryDate));

    this.PurchaseInvoiceData.TaxAmount = this.Tax;
    this.PurchaseInvoiceData.NetAmount = this.GrandTotal;
    this.PurchaseInvoiceData.GrossAmount = this.TotalBeforeDiscount;

    //this.PurchaseInvoiceData.DocID = this.CurrentPurchaseOrderHeaderDetailsController.DocID;
    //this.PurchaseInvoiceData.PurchaseOrderCode = this.CurrentPurchaseOrderHeaderDetailsController.PurchaseOrderCode;
    //this.PurchaseInvoiceData.InvoiceStatus = this.CurrentPurchaseOrderHeaderDetailsController.OrderStatus;
    //this.PurchaseInvoiceData.OwnerStore = this.CurrentPurchaseOrderHeaderDetailsController.ShipToLocationCode;
    //this.PurchaseInvoiceData.OwnerStoreName = this.CurrentPurchaseOrderHeaderDetailsController.ShipToLocation;

    //this.PurchaseInvoiceData.VendorCode = this.CurrentPurchaseOrderHeaderDetailsController.SupplierCode;
    //this.PurchaseInvoiceData.VendorName = this.CurrentPurchaseOrderHeaderDetailsController.SupplierName;
    //this.PurchaseInvoiceData.RefDocNo = this.CurrentPurchaseOrderHeaderDetailsController.RefNo;
    //this.PurchaseInvoiceData.InvDate = this.CurrentPurchaseOrderHeaderDetailsController.OrderDate;
    //this.PurchaseInvoiceData.PaymentDue = this.CurrentPurchaseOrderHeaderDetailsController.DeliveryDate;

    //this.PurchaseInvoiceData.TaxAmount = this.CurrentPurchaseOrderHeaderDetailsController.Tax;
    //this.PurchaseInvoiceData.NetAmount = this.CurrentPurchaseOrderHeaderDetailsController.GrandTotal;
    //this.PurchaseInvoiceData.GrossAmount = this.CurrentPurchaseOrderHeaderDetailsController.TotalBeforeDiscount;

    this.PurchaseInvoiceData.VendorInvoiceCode = 0;

    this.PurchaseInvoiceData.Items = new Array<VendorInvoiceItemRequest>();
    for (var i = 0; i < this.CurrentPurchaseOrderDetailsController.length; i++) {
      var piItem = new VendorInvoiceItemRequest();
      var orderItem = this.CurrentPurchaseOrderDetailsController[i];

      piItem.ItemCode = orderItem.MaterialCode;
      piItem.ItemDescription = orderItem.MaterialDescription;
      piItem.Quantity = orderItem.Quantity;
      piItem.UOM = orderItem.UOM;
      piItem.UnitPrice = orderItem.UnitPrice;
      piItem.TaxPercent = orderItem.TaxPercent;
      piItem.TaxAmount = orderItem.TaxAmount;
      piItem.BonusQuantity = orderItem.BonusQuantity;
      piItem.TotalOrderQuantity = orderItem.TotalOrderQuantity;
      piItem.Mrp = orderItem.MRP;
      piItem.Pack = orderItem.Pack;
      piItem.PurchasePrice = orderItem.PurchasePrice;
      piItem.SellingPrice = orderItem.SellingPrice;
      piItem.ExpiryDate = new Date(this.parserFormatter.format(this.DefaultExpDate));

      //piItem.BatchNo = this.BatchNo;
      //piItem.ExpiryDate = this.ExpiryDate;

      this.PurchaseInvoiceData.Items.push(piItem);

    }

  }
  GetPurchaseOrderDetailsController() {
    this.StartRefreshing();
    this.CurrentPurchaseOrderDetailsRequest.DOC = this.DocIDdata;
    this.CurrentPurchaseOrderDetailsRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseOrderDetailsController(this.CurrentPurchaseOrderDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPurchaseIndentItemsController = this.ApiResData.Result;
          this.PurchaseOrderDataHeader = this.ApiResData.Result;
          this.PurchaseInvoiceData = new SaveVendorInvoice();
          this.CurrentPurchaseOrderDetailsController = this.PurchaseOrderDataHeader.OrderItems;
          this.CurrentPurchaseOrderHeaderDetailsController = this.PurchaseOrderDataHeader.OrderHeader;

          this.stopRefreshing();
          //alert(this.CurrentPurchaseIndentsHeaderController.IndentNo);
          this.CopyOrderToInvoice();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  LoadItemsGeneric() {
    var getReq = new PurchaseOrderDetailsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101041;
    getReq.DOC = this.DocIDdata;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101041;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentPurchaseOrderDetailsController = JSON.parse(data);
          this.PurchaseInvoiceData = new SaveVendorInvoice();
          //alert(this.CurrentPurchaseOrderDetailsController.length);
          //this.CurrentPurchaseOrderDetailsController = this.PurchaseOrderDataHeader.OrderItems;
          //this.CurrentPurchaseOrderHeaderDetailsController = this.PurchaseOrderDataHeader.OrderHeader;
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.CopyOrderToInvoice();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Storelistpipe, private spinner: NgxSpinnerService


  ) { }
  public OrderDateDay: any;
  public OrderDateMonth: any;
  public OrderDateYear: any;
  public DeliveryDateDay: any;
  public DeliveryDateMonth: any;
  public DeliveryDateYear: any;
  ngOnInit() {
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode2 = AppData.Instance().UserLoginDetails.ActorCode;
    this.DocIDdata = this.route.snapshot.paramMap.get('DocIDdata');

    this.PurchaseOrderCode = this.route.snapshot.paramMap.get('PurchaseOrderCode');
    this.OrderStatus = this.route.snapshot.paramMap.get('OrderStatus');
    this.ShipToLocationCode = this.route.snapshot.paramMap.get('ShipToLocationCode');
    this.ShipToLocationdata = this.route.snapshot.paramMap.get('ShipToLocationdata');
    this.SupplierCode = this.route.snapshot.paramMap.get('SupplierCode');
    this.SupplierName = this.route.snapshot.paramMap.get('SupplierName');
    this.RefNo = this.route.snapshot.paramMap.get('RefNo');
    this.OrderDate = this.route.snapshot.paramMap.get('OrderDate');
    this.DeliveryDate = this.route.snapshot.paramMap.get('DeliveryDate');
    this.Tax = this.route.snapshot.paramMap.get('Tax');
    this.GrandTotal = this.route.snapshot.paramMap.get('GrandTotal');
    this.TotalBeforeDiscount = this.route.snapshot.paramMap.get('TotalBeforeDiscount');
    this.BranchName = this.route.snapshot.paramMap.get('BranchName');

    //this.OrderDateDay = this.route.snapshot.paramMap.get('Day');
    //this.OrderDateMonth = this.route.snapshot.paramMap.get('month');
    //this.OrderDateYear = this.route.snapshot.paramMap.get('year');

    //this.DeliveryDateDay = this.route.snapshot.paramMap.get('Day');
    //this.DeliveryDateMonth = this.route.snapshot.paramMap.get('month');
    //this.DeliveryDateYear = this.route.snapshot.paramMap.get('year');

    //this.OrderDatedata = { year: this.OrderDateYear, month: this.OrderDateMonth, day: this.OrderDateDay };
    //this.DeliveryDatedata = { year: this.DeliveryDateYear, month: this.DeliveryDateMonth, day: this.DeliveryDateDay };

    //this.OrderDatedate = {
    //  year: this.OrderDate.,
    //  month: this.OrderDate.getMonth() + 1,
    //  day: this.OrderDate.getDate()
    //};

    //this.DeliveryDatedata = {
    //  year: this.DeliveryDate.getFullYear(),
    //  month: this.DeliveryDate.getMonth() + 1,
    //  day: this.DeliveryDate.getDate()
    //};
    this.LoadItemsGeneric();
    //this.LoadItems();
    this.InvoiceDate = {
      year: this.TodayDate.getFullYear(),
      month: this.TodayDate.getMonth() + 1,
      day: this.TodayDate.getDate()
    };
    this.PaymentDueDate = {
      year: this.TodayDate.getFullYear(),
      month: this.TodayDate.getMonth() + 1,
      day: this.TodayDate.getDate() + 15
    };
    this.DefaultExpDate = {
      year: this.TodayDate.getFullYear(),
      month: this.TodayDate.getMonth() + 1,
      day: this.TodayDate.getDate()
    };
    this.CurrentSaveVendorInvoiceRequest = new SaveVendorInvoice();
    this.CurrentSaveVendorInvoiceRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  }
  SaveData() {
    //this.isvisible = false;
    this.spinner.show();
    this.CurrentSaveVendorInvoiceRequest.DocID = this.PurchaseInvoiceData.DocID;
    this.CurrentSaveVendorInvoiceRequest.Facility = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveVendorInvoiceRequest.InvDate = new Date(this.parserFormatter.format(this.InvoiceDate));
    this.CurrentSaveVendorInvoiceRequest.PaymentDue = new Date(this.parserFormatter.format(this.PaymentDueDate));
    this.CurrentSaveVendorInvoiceRequest.VendorCode = this.PurchaseInvoiceData.VendorCode;
    this.CurrentSaveVendorInvoiceRequest.VendorName = this.PurchaseInvoiceData.VendorName;
    this.CurrentSaveVendorInvoiceRequest.VendorInvoiceCode = this.PurchaseInvoiceData.VendorInvoiceCode;
    this.CurrentSaveVendorInvoiceRequest.RefDocNo = this.PurchaseInvoiceData.RefDocNo;
    this.CurrentSaveVendorInvoiceRequest.PurchaseOrderCode = this.PurchaseInvoiceData.PurchaseOrderCode;
    this.CurrentSaveVendorInvoiceRequest.InvoiceStatus = this.PurchaseInvoiceData.InvoiceStatus;
    this.CurrentSaveVendorInvoiceRequest.Remarks = this.PurchaseInvoiceData.Remarks;
    this.CurrentSaveVendorInvoiceRequest.Notes = this.PurchaseInvoiceData.Notes;
    this.CurrentSaveVendorInvoiceRequest.OwnerStore = this.PurchaseInvoiceData.OwnerStore;
    this.CurrentSaveVendorInvoiceRequest.OwnerStoreName = this.PurchaseInvoiceData.OwnerStoreName;
    this.CurrentSaveVendorInvoiceRequest.ConditionalOperator = 10;
    this.CurrentSaveVendorInvoiceRequest.Items = this.PurchaseInvoiceData.Items;
    this.CurrentSaveVendorInvoiceRequest.TaxAmount = this.PurchaseInvoiceData.TaxAmount;
    this.CurrentSaveVendorInvoiceRequest.TotalBeforeDesc = this.PurchaseInvoiceData.TotalBeforeDesc;
    this.CurrentSaveVendorInvoiceRequest.GrossAmount = this.PurchaseInvoiceData.GrossAmount;
    this.CurrentSaveVendorInvoiceRequest.NetAmount = this.PurchaseInvoiceData.NetAmount;
    //this.CurrentSaveVendorInvoiceRequest.Terms = this.TermsAndConditions;
    this.CurrentSaveVendorInvoiceRequest.InvFormattedCode = this.PurchaseInvoiceData.InvFormattedCode;
    this.CurrentSaveVendorInvoiceRequest.InvoiceStatus = this.PurchaseInvoiceData.InvoiceStatus;
    this.actorservice.Save<SaveVendorInvoice>(
      this.CurrentSaveVendorInvoiceRequest, S_Methods.SaveVendorInvoices
    )
      .subscribe((result) => {
        this.ApiResData = result;
        if (result.Result > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.spinner.hide();
          this.isvisible = false;
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");
          this.stopRefreshing();
          this.spinner.hide();
        }
      },
        (error) => {
          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }

  EditItems(PurchaseInvoiceData: SaveVendorInvoice, input: VendorInvoiceItemRequest) {
    const modalRef = this.modalService.open(NgbEditPIitemsModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.PurchaseInvoiceItem = input;
    modalRef.componentInstance.PurchaseInvoiceData = PurchaseInvoiceData;
    modalRef.componentInstance.VendorName = this.PurchaseInvoiceData.VendorName;
    modalRef.componentInstance.OwnerStoreName = this.ShipToLocation;
    //modalRef.componentInstance.OwnerStoreName = this.CurrentPurchaseOrderHeaderDetailsController.ShipToLocation;
    modalRef.componentInstance.ExpiryDate = new Date(this.parserFormatter.format(this.DefaultExpDate));
    modalRef.componentInstance.PurchaseOrderCode = this.PurchaseOrderCode;
    //modalRef.componentInstance.PurchaseOrderCode = this.CurrentPurchaseOrderHeaderDetailsController.PurchaseOrderCode;
    modalRef.result.then((l: VendorInvoiceItemRequest) => {
      input.UnitPrice = l.UnitPrice;
      input.TotalOrderQuantity = l.Quantity + l.BonusQuantity;
      input.BonusQuantity = l.BonusQuantity;
      input.TaxPercent = l.TaxPercent;

      input.Quantity = l.Quantity;



      input.UOM = l.UOM;
      input.Mrp = l.Mrp;
      input.Pack = l.Pack;
      input.PurchasePrice = l.PurchasePrice;
      input.SellingPrice = l.SellingPrice;
      input.TaxAmount = ((l.Quantity) * l.PurchasePrice * l.TaxPercent) / 100;
      //input.TaxAmount = ((l.Quantity + l.BonusQuantity) * l.PurchasePrice * l.TaxPercent) / 100;
      input.BatchNo = l.BatchNo;
      input.ExpiryDate = l.ExpiryDate;
      // alert(l.ExpiryDate);
      this.CalculateTotals();
    });
  }
  CalculateTotals() {

    this.PurchaseInvoiceData.TaxAmount = this.PurchaseInvoiceData.Items.filter((item) => item.TaxAmount)
      .map((item) => +item.TaxAmount)
      .reduce((sum, current) => sum + current);
    this.PurchaseInvoiceData.GrossAmount = this.PurchaseInvoiceData.Items.filter((item) => item.PurchasePrice)
      .map((item) => item.Quantity * item.PurchasePrice)
      .reduce((sum, current) => sum + current);
    //this.PurchaseInvoiceData.GrossAmount = this.PurchaseInvoiceData.Items.filter((item) => item.PurchasePrice)
    //  .map((item) => +item.PurchasePrice)
    //  .reduce((sum, current) => sum + current) * this.PurchaseInvoiceData.Items.filter((item) => item.Quantity)
    //  .map((item) => +item.Quantity)
    //    .reduce((sum, current) => sum + current);
    this.PurchaseInvoiceData.NetAmount = this.PurchaseInvoiceData.GrossAmount + this.PurchaseInvoiceData.TaxAmount;

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  Cancel() {
      this.router.navigate(['healins/materialinvoice']);
  }
  ShipToLocation: number = 0;
  public ShipToLocationname: string;
  onAssignedShipToLocationname(event: any) {
    if (event != null) {
      this.ShipToLocationname = event;
      // this.StoreItems();
    }
  }

}


